import React from 'react';
import Box from 'components/react-styled-core/Box';

const Container = ({ children }) => (
    <Box
        boxSizing="border-box"
        position="relative"
        width={['100%', '100%', '1088px']}
        height="100%"
        m="0 auto"
        px={['6x', '6x', '8x']}
    >
        {children}
    </Box>
);

export default Container;
